<template>
  <v-card id="calls-list" class="mb-5">
    <v-card-title>
      Предыдущие обращения
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :options.sync="options"
      :server-items-length="meta.total"
      @click:row="showItem"
    >
      <template v-slot:top>
        <v-container fluid>
          <v-row no-gutters>
            <v-col cols="12" sm="3" class="mr-3">
              <date-range-picker v-model="filter.date" @input="load" dense />
            </v-col>

            <v-col cols="12" sm="3" class="mr-3">
              <v-select
                class="ma-0 pa-0"
                dense
                hide-details
                label="Тип оказания услуги"
                item-text="name"
                item-value="id"
                :items="typeList"
                v-model="filter.type"
                @change="load()"
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:item.attachments="{ item }">
        <div
          @click.prevent="
            e => {
              e.stopPropagation();
            }
          "
        >
          <attachment-list-viewer :attachments="item.attachments" />
        </div>
      </template>

      <template v-slot:item.consultation="{ item }">
        <template v-if="item.consultation_id">
          <v-btn text @click="showConsultation(item.consultation_id)">Заключение</v-btn>
        </template>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon class="mr-2" @click="show(item)">
          mdi-pencil
        </v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import throttle from "lodash/throttle";
import { mapState } from "vuex";
import { QueryHelper } from "@/services/query-helper";
import DateRangePicker from "@/components/forms/DateRangePicker";
import AttachmentListViewer from "@/views/components/AttachmentListViewer";
import { CustomerService } from "@/services/api/customer.service";
import AddDocument from "@/modules/documents/add-document/AddDocument.vue";
import ModalOrderHistory from "@/views/pages/previous-appeal/components/ModalOrderHistory";
import { ReferencesRepository } from "@/modules/references/references.repository.js";

export default {
  components: { AttachmentListViewer, DateRangePicker },

  data: () => ({
    loading: false,
    typeList: [],
    options: {},
    filter: {
      date: null,
      type: null,
    },
    headers: [
      { text: "№ заказа", value: "id" },
      { text: "Статус", value: "status", align: "center" },
      { text: "Дата проведения", value: "date", align: "center" },
      { text: "Способ оказания услуги", value: "type", align: "center" },
      { text: "Услуга", value: "service_name", align: "center" },
      { text: "ФИО врача", value: "doctor_name", align: "center" },
      { text: "Вложения", value: "attachments", align: "center" },
      { text: "Заключение", value: "consultation", align: "center" },
    ],
  }),

  computed: {
    customerId() {
      return this.$store.state.customer.id;
    },

    ...mapState("previousAppeal", ["items", "meta"]),
  },

  watch: {
    options: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },

  async created() {
    this.typeList = await ReferencesRepository.serviceProvidingWays();
  },

  methods: {
    async load() {
      this.loading = true;
      const params = {
        doctor_id: this.$store.state.auth.id,
        search: this.search,
        ...QueryHelper.tableSorting(this.options),
        ...QueryHelper.filter(this.filter),
        ...QueryHelper.pagination(this.options, this.meta.total),
      };

      try {
        const r = await this.$http.get(`v1/customers/${this.customerId}/history`, { params }).then(r => r.data);
        this.$store.commit("previousAppeal/SET_ITEMS", r.data);
        this.$store.commit("previousAppeal/SET_META_TOTAL", r.meta.total);
      } catch (e) {
        // TODO: Обработать ошибку
        console.error(e);

        this.$store.commit("previousAppeal/SET_ITEMS", []);
        this.$store.commit("previousAppeal/SET_META_TOTAL", 0);
        this.meta.total = 0;
      }

      this.loading = false;
    },

    apiSearch: throttle(async function apiSearchHandler() {
      await this.load();
    }, 1000),

    async showConsultation(consultationId) {
      const r = await CustomerService.getDocument(this.customerId, consultationId);
      await this.$dialog.showAndWait(AddDocument, { readonly: true, customerForm: r, width: 600, persistent: true });
    },

    async showItem(item) {
      const r = await CustomerService.getOrderHistory(this.customerId, item.id);
      await this.$dialog.show(ModalOrderHistory, { readonly: true, order: r, width: "min(90%, 700px)" });
    },
  },
};
</script>

<style scoped></style>
